import type { Dataset, QueryState } from '@/services/nlq/nlq-service';
import type { ExtendedChartWidgetProps } from './types';

/**
 * These helpers accept `savedChartWidgetProps` as an explicit parameter so TypeScript
 * does not infer `never` on the mutable closure-captured variable inside buildChartEngine.
 * See https://github.com/microsoft/TypeScript/issues — TS 5.x sequentially narrows
 * closed-over `let` variables inside object literals after a ternary branch.
 */

export function datasetFromSavedChartWidget(
	naturalResponseEnabled: boolean | undefined,
	props: ExtendedChartWidgetProps | null,
): Dataset | undefined {
	if (!naturalResponseEnabled || props == null) {
		return undefined;
	}
	const d = props.dataset;
	if (d === undefined || d === null) {
		return undefined;
	}
	return d;
}

export function queryStateFromSavedChartWidget(
	props: ExtendedChartWidgetProps | null,
): QueryState | undefined {
	return props?.queryState ?? undefined;
}
